import { render, staticRenderFns } from "./OvertimeIssue.vue?vue&type=template&id=6a5564b1&scoped=true"
import script from "./OvertimeIssue.vue?vue&type=script&lang=js"
export * from "./OvertimeIssue.vue?vue&type=script&lang=js"
import style0 from "./OvertimeIssue.vue?vue&type=style&index=0&id=6a5564b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5564b1",
  null
  
)

export default component.exports